module.exports = __webpack_public_path__ + "img/01.fd210432.png";